import React, { Component } from 'react';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
// import StarRatingComponent from 'react-star-rating-component';
import cjquery from 'jquery';
import StarRatings from 'react-star-ratings';
import { Tooltip } from 'reactstrap';
import language from '../../../assets/languages/language';
import ValidateSaveReportIcon from '../../Common/ValidateSaveReportIcon';
import { renderHTMLContent } from '../../../common/function';
import ViewQuestion from '../../../Components-2025/QuestionBank/ViewQuestion';
// import AppRoutes from '../config/AppRoutes';
/* eslint-disable*/
class Cfa2Beginquiz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successAlert: false,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset) : 0,
      all_question_id: '',
      question_length: '',
      questions: [],
      question_offset: 0,
      question_display: '',
      timer_value: '',
      include_timer: '',
      user_time_value: '',
      first_question_id: '',
      display_question: '',
      save_text: `${language.LC().SAVE_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'icon-control-pause pause_btn',
      count: 0,
      ValidToken: false,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count_end_message: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      timer_display: 'card-block',
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      next_block_cases: '',
      previ_block_cases: '',
      already_answered_status: '',
      caseid: '',
      all_cases: [],
      cases_display: '',
      cases_name: '',
      cases_length: '',
      case_id: '',
      casesquestion_length: '',
      chapters: '',
      chatername: '',
      chapter_id: '',
      case_no: '',
      chapter_no_2025: '',
      display_loader: 'show_block',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      exam_type: 'cfa_2',
      showCompletionQuestion: false,
      selectedChoice: '',
      showAnswer: false,
      selected: '',
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: false,
      lastCase: null,
      display_cases: '',
    };
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  /*
  -----------------------------------------------------------------
    Function to change time every second and store in database
  -----------------------------------------------------------------
  */
  tick() {
    if (this.state.count > 0) {
      var countValue = this.state.count - 1;
      var insert_time = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        user_time_value: countValue,
      };
      FD.callAPI(`${App_data.backend_api}/cfa_2_2027quizes/insertTimer`, insert_time).then(
        (resp) => { },
      );
      this.setState({
        count: countValue,
        timer_display: 'card-block',
      });
    } else {
      this.setState({
        timer_display: 'card hide_block',
        count_end_message: "Time's Up",
      });
      clearInterval(this.timer);
    }
  }

  /*
  -------------------------------
    it is use to redirect page
  -------------------------------
  */
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.state.offset === 0) {
      this.setState({ previ_block_cases: 'card hide_block' });
    }
    if (this.state.question_offset === 0) {
      this.setState({ previ_block: 'card hide_block' });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      quiz_id: this.state.quiz_id,
    };
    /*
  ----------------------------------  
    Api to fetch Quiz by quiz id
  ----------------------------------  
    */
    FD.callAPI(`${App_data.backend_api}/cfa_2_2027quizes/getQuize`, data).then((resp) => {
      if (resp.success) {
        var all_questions = JSON.parse(resp.singlequiz);
        var all_cases = JSON.parse(resp.case_id);
        this.setState({
          all_cases: all_cases,
          timer_value: resp.timer_value,
          cases_length: all_cases.length,
          user_time_value: resp.user_time_value,
        });

        if (all_cases.length - 1 === this.state.offset) {
          this.setState({ next_block_cases: 'card hide_block' });
        }

        const initialCount = resp.user_time_value > 0 ? resp.user_time_value : resp.timer_value;
        this.setState({
          count: initialCount,
          count_temp: initialCount,
        });

        if (!this.state.clicked) {
          this.timer = setInterval(this.tick.bind(this), 1000);
          this.setState({
            timer_stop: false,
            timerstopbtn: 'pause_btn icon-control-pause',
            timer_display: 'card-block',
          });
        } else {
          this.setState({
            timer_stop: true,
            timerstopbtn: 'pause_btn icon-control-play',
            timer_display: 'card-block',
          });
        }

        for (var i = 0; i < all_cases.length; i++) {
          if (parseInt(this.props.params.offset) === i) {
            this.setState({ case_id: all_cases[i] });
            var data = {
              token: this.state.token,
              idname: this.state.idname,
              casesId: all_cases[i],
            };
            FD.callAPI(`${App_data.backend_api}/cfa_2_2027quizes/getCasesbyId`, data).then(
              (resp) => {
                if (resp.success) {
                  this.context.router.push({
                    pathname: `/cfa2/2027/beginquiz/${this.state.quiz_id}/${this.state.offset}`,
                  });
                  this.setState({
                    cases_display: resp.casesdiscription,
                    chapter_id: resp.casesdiscription.chapter_no_2025,
                    case_no: resp.casesdiscription.case_number,
                    chapter_no_2025: resp.casesdiscription.chapter_no_2025,
                  });
                  var questionid = '';
                  var chapter_id = resp.casesdiscription.chapter_no_2025;
                  var data = {
                    token: this.state.token,
                    idname: this.state.idname,
                    chapter_id: resp.casesdiscription.chapter_no_2025,
                  };
                  FD.callAPI(
                    `${App_data.backend_api}/cfa_2_2027question_bank/getChaptersbyID`,
                    data,
                  ).then((respchapter) => {
                    if (respchapter.success) {
                      this.setState({
                        chaptername: respchapter.chapterdata.chapter_name,
                        chapters: respchapter.chapterdata,
                      });

                      const param = {
                        token: this.state.token,
                        idname: this.state.idname,
                        case_id: resp.casesdiscription.id,
                        isQuiz: true,
                        quiz_id: this.state.quiz_id,
                      };
                      FD.callAPI(
                        `${App_data.backend_api}/cfa_2_2027question_bank/getCasesquestion`,
                        param,
                      ).then((resp_question) => {
                        if (resp_question.success) {
                          const questionData =
                            resp_question.questions_details[this.state.question_offset];
                          const selectedChoice =
                            questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
                          const rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
                          const answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
                          let showAnswer = false;
                          let selected = '';

                          if (selectedChoice) {
                            selected = selectedChoice;
                            showAnswer = true;
                          } else if (answerStatus) {
                            if (rightAnswer === 1) {
                              selected = `choice_${questionData.answer}`;
                              showAnswer = true;
                            } else if (!rightAnswer) {
                              const correct = `choice_${questionData.answer}`;
                              const choices = Object.keys(questionData).filter(
                                (key) =>
                                  key.startsWith('choice') &&
                                  key !== `choice_${questionData.answer}`,
                              );
                              selected = choices.length > 0 ? choices[0] : '';
                              showAnswer = true;
                            }
                          }
                          let boxA = 'answer_box',
                            boxB = 'answer_box',
                            boxC = 'answer_box';
                          let result_block = 'card hide_block',
                            text_color = 'card-header',
                            result = '',
                            clicked = false;

                          if (selected) {
                            const correct = questionData.answer
                              ? `choice_${questionData.answer}`
                              : '';
                            if (selected === 'choice_a') {
                              boxA =
                                selected === correct ? 'answer_box success' : 'answer_box failure';
                            } else if (selected === 'choice_b') {
                              boxB =
                                selected === correct ? 'answer_box success' : 'answer_box failure';
                            } else if (selected === 'choice_c') {
                              boxC =
                                selected === correct ? 'answer_box success' : 'answer_box failure';
                            }
                            if (correct) {
                              if (selected === correct) {
                                text_color = 'card-header text_success';
                                result = 'CORRECT';
                              } else {
                                text_color = 'card-header text_failure';
                                result = 'INCORRECT';
                              }
                              result_block = 'card show_block';
                            }
                            clicked = true;
                          }
                          this.setState({
                            question_display: questionData,
                            question_length: resp_question.questions_details.length,
                            questions: resp_question.questions_details,
                            question_offset: this.state.question_offset,
                            selectedChoice: selected,
                            choice: selected,
                            clicked,
                            choice_a: boxA,
                            choice_b: boxB,
                            choice_c: boxC,
                            result_block,
                            text_color,
                            result,
                            showAnswer,
                            selected,
                          });
                          questionid = questionData.id;

                          var data_check = {
                            token: this.state.token,
                            idname: this.state.idname,
                            quiz_id: this.state.quiz_id,
                            question_id: questionid,
                          };
                          /*
                      --------------------------------------------
                        Api to fetch question and check answered 
                      --------------------------------------------  
                        */

                          FD.callAPI(
                            `${App_data.backend_api}/cfa_2_2027quizes/checkAnswered`,
                            data_check,
                          ).then((resp_inner) => {
                            this.setState({
                              already_answered_status: resp_inner.message,
                            });
                          });
                          this.setState({ display_loader: 'hide_block' });
                          clearInterval(this.timer);
                          if (selected) {
                            this.setState({
                              timer_stop: true,
                              timerstopbtn: 'pause_btn icon-control-play',
                            });
                          } else {
                            this.setState({
                              timer_stop: false,
                              timerstopbtn: 'pause_btn icon-control-pause',
                            });
                            this.timer = setInterval(this.tick.bind(this), 1000);
                          }
                          var params_fav = {
                            token: this.state.token,
                            question_id: questionid,
                            idname: this.state.idname,
                            chapter_id: chapter_id,
                          };
                          FD.callAPI(
                            `${App_data.backend_api}/cfa_2_2027question_bank/getFavQuestions`,
                            params_fav,
                          ).then((responsefav) => {
                            if (responsefav.success) {
                              this.setState({
                                save_question:
                                  'book-mark pointer_class margin_right_10 margin_bottom_10',
                                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                                bookmarkColor: 'rgb(54, 141, 84)',
                                save_text: `${language.LC().Question_Saved}`,
                              });
                            }
                          });
                          var params = {
                            token: this.state.token,
                            idname: this.state.idname,
                            question_id: questionid,
                          };
                          /*
                        ------------------------------------------ 
                          Api to fetch flashcard by question id
                        ------------------------------------------
                          */
                          FD.callAPI(
                            `${App_data.backend_api}/cfa_2_2027question_bank/getFlashCards`,
                            params,
                          ).then((response) => {
                            if (response.success) {
                              this.setState({ ValidToken: true });
                              if (response.flash_cards.length > 0) {
                                this.setState({
                                  flash_form: 'col-md-12 hide_block',
                                });
                                var flash_cards = response.flash_cards.map((items, index) => (
                                  <li key={index}>
                                    <div className=''>
                                      <ul className='icon_list'>
                                        <li>
                                          <a
                                            className='pointer_class'
                                            onClick={this._editFlash.bind(this, items)}
                                          >
                                            <i className='fa fa-pencil' />
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            className='pointer_class'
                                            onClick={this._deleteFlash.bind(this, items)}
                                          >
                                            <i className='fa fa-close' />
                                          </a>
                                        </li>
                                      </ul>
                                      <div className={this.state.flash_class}>
                                        <h4 />
                                        <p>{items.flash_card}</p>
                                      </div>
                                    </div>
                                  </li>
                                ));
                              } else {
                                this.setState({
                                  flash_form: 'col-md-12 display_block',
                                });
                                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                              }
                              this.setState({ flash_data: flash_cards });
                            } else {
                              var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                              this.setState({
                                ValidToken: false,
                                flash_data: flash_cards,
                                flash_form: 'col-md-12 display_block',
                              });
                            }
                            return response;
                          });
                          this.setState({ records: '' });
                          // Fetch rating for this question
                          var params_rating = {
                            token: this.state.token,
                            question_id: questionid,
                            idname: this.state.idname,
                          };
                          FD.callAPI(
                            `${App_data.backend_api}/cfa_2_2027question_bank/getCfaratting`,
                            params_rating,
                          ).then((response) => {
                            if (response.success) {
                              this.setState({ rated: true });
                              response.ratting.map((items) => {
                                this.setState({
                                  rating: items.ratting,
                                  ratting_text: `${language.LC().RATED}`,
                                });
                              });
                            } else {
                              this.setState({
                                rated: false,
                                rating: 0,
                                ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
                              });
                            }
                          });
                        }
                      });
                    } else {
                      this.setState({ ValidToken: false });
                    }
                  });
                }
              },
            );
          }
        }
      }
      return resp;
    });
  }
  componentDidUpdate() {
    if (
      this.state.showCompletionQuestion &&
      this.state.lastCase &&
      this.state.cases_display.id != this.state.lastCase &&
      !this.state.markCompleted
    ) {
      document.getElementById('mark_not_completed') &&
        document.getElementById('mark_not_completed').checked
        ? (document.getElementById('mark_not_completed').checked = false)
        : '';
      document.getElementById('mark_completed') && document.getElementById('mark_completed').checked
        ? (document.getElementById('mark_completed').checked = false)
        : '';
    }
  }
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue);
    {
      var params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(`${App_data.backend_api}/cfa_2_2027question_bank/UpdateCfaRatting`, params).then(
        (response) => {
          if (response.success) {
            this.setState({ rated: 1, ratting_text: 'Rated ' });
          }
        },
      );
    }

    this.setState({ rating: nextValue });
    var params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(`${App_data.backend_api}/cfa_2_2027question_bank/getCfaratting`, params).then(
      (response) => {
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map((items) => {
              this.setState({
                rating: items.ratting,
                ratting_text: `${language.LC().RATED}`,
              });
            });
          } else {
            var params = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: item.id,
              ratting: nextValue,
            };
            FD.callAPI(
              `${App_data.backend_api}/cfa_2_2027question_bank/saveCfaratting`,
              params,
            ).then((response) => {
              if (response.success) {
                this.setState({
                  rated: 1,
                  ratting_text: `${language.LC().RATED}` + nextValue + ' ' + 'stars',
                });
              }
            });
          }
        } else {
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: item.id,
            ratting: nextValue,
          };
          FD.callAPI(`${App_data.backend_api}/cfa_2_2027question_bank/saveCfaratting`, params).then(
            (response) => {
              if (response.success) {
                this.setState({
                  rated: 1,
                  ratting_text: `${language.LC().RATED}` + nextValue + ' ' + 'stars',
                });
              }
            },
          );
        }
      },
    );
  }

  _getAnswer = (choice, e) => {
    let selectedChoice = '';
    if (typeof choice === 'string') {
      selectedChoice = choice.startsWith('choice_') ? choice : `choice_${choice}`;
    } else if (Array.isArray(choice) && typeof choice[0] === 'string') {
      selectedChoice = choice[0].startsWith('choice_') ? choice[0] : `choice_${choice[0]}`;
    }
    this.setState({ choice: selectedChoice, selectedChoice, clicked: false });
    if (selectedChoice === 'choice_a') {
      this.setState({
        choice_a: 'answer_box clicked_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
      });
    } else if (selectedChoice === 'choice_b') {
      this.setState({
        choice_b: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_c: 'answer_box',
      });
    } else if (selectedChoice === 'choice_c') {
      this.setState({
        choice_c: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_b: 'answer_box',
      });
    }
  };

  /*
  -------------------------------------------------------------------------
    Function to Display Saved Question on button and save in database
  -------------------------------------------------------------------------
  */
  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      chapter_id: this.state.chapter_id,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      FD.callAPI(`${App_data.backend_api}/cfa_2_2027question_bank/unsaveQuestion`, data).then(
        (resp) => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
              save_text: `${language.LC().SAVE_QUESTION}`,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(`${App_data.backend_api}/cfa_2_2027question_bank/saveQuestion`, data).then(
        (resp) => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              bookmarkColor: 'rgb(54, 141, 84)',
              save_text: `${language.LC().Question_Saved}`,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    }
  };

  _getResult = (item, e) => {
    const chosen_answer = this.state.choice;
    if (chosen_answer && !this.state.clicked) {
      clearInterval(this.timer);
      var right_answer = 0;
      this.setState({
        result_block: 'card show_block',
        clicked: true,
        timer_stop: true,
        timerstopbtn: 'pause_btn icon-control-play',
        timer_display: 'card-block',
      });
      if (`choice_${item.answer}` === chosen_answer) {
        right_answer = 1;
        if (chosen_answer === 'choice_a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (chosen_answer === 'choice_b') {
          this.setState({ choice_b: 'answer_box success' });
        } else if (chosen_answer === 'choice_c') {
          this.setState({ choice_c: 'answer_box success' });
        }
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
        });
      } else {
        right_answer = 0;
        if (chosen_answer === 'choice_a') {
          this.setState({ choice_a: 'answer_box danger' });
        } else if (chosen_answer === 'choice_b') {
          this.setState({ choice_b: 'answer_box danger' });
        } else if (chosen_answer === 'choice_c') {
          this.setState({ choice_c: 'answer_box danger' });
        }
        if (item.answer === 'a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (item.answer === 'b') {
          this.setState({ choice_b: 'answer_box success' });
        } else if (item.answer === 'c') {
          this.setState({ choice_c: 'answer_box success' });
        }
        this.setState({
          result: 'INCORRECT',
          text_color: 'card-header text_failure',
          result_block: 'card show_block',
        });
      }

      const idx = this.state.question_offset;
      const questionsCopy = [...this.state.questions];
      if (questionsCopy[idx]) {
        if (!questionsCopy[idx].cfa2_2027_answer_quizzes) {
          questionsCopy[idx].cfa2_2027_answer_quizzes = {};
        }
        questionsCopy[idx].cfa2_2027_answer_quizzes.selected_choice = chosen_answer;
        questionsCopy[idx]['cfa2_2027_answer_quizzes.selected_choice'] = chosen_answer;
        this.setState({ questions: questionsCopy });
      }

      if (!this.state.validated) {
        var data = {
          token: this.state.token,
          idname: this.state.idname,
          quiz_id: this.state.quiz_id,
          question_id: this.state.questions[this.state.question_offset].id,
          answer: right_answer,
          selectedChoice: chosen_answer,
        };
        FD.callAPI(App_data.backend_api + '/cfa_2_2027quizes/answerQuiz', data).then((resp) => {
          if (resp.success) {
            var data = {
              token: this.state.token,
              idname: this.state.idname,
              question_id: this.state.questions[this.state.question_offset].id,
              right_answer: right_answer,
              time_done: 0,
              chapter_id: this.state.chapter_id,
              selected_choice: this.state.choice,
            };

            FD.callAPI(App_data.backend_api + '/cfa_2_2027question_bank/saveStats', data).then(
              (resp) => { },
            );
            this.setState({ ValidToken: true, validated: true });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        });
      }
    }
  };

  /*
  -------------------------------------------------------
    Function to redirect page to readings beforestart
  ------------------------------------------------------ 
  */
  _getSummary = () => {
    this.context.router.push({
      pathname: `/cfa2/2027/beforestart/${this.state.quiz_id}/${'abondon'}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        status_send: 'abondon',
      },
    });
  };

  /*
------------------------------------
  Function to start or stop timer
------------------------------------
*/

  _timer_funct = (item, e) => {
    // If the question is already attempted, do nothing
    if (this.state.clicked || this.state.validated) {
      return;
    }
    if (this.state.timer_stop) {
      this.setState({
        timer_stop: false,
        timerstopbtn: 'pause_btn icon-control-pause',
      });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
    } else {
      this.setState({
        timer_stop: true,
        timerstopbtn: 'pause_btn icon-control-play',
      });
      clearInterval(this.timer);
    }
  };

  /*
  ----------------------------------
    Function to show Report box
  ---------------------------------
  */
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  /*
  ---------------------------------------------
    Funcion to save new report question
  ---------------------------------------------
  */
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment')
      ? document.getElementById('comment').value
      : null;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2027question_bank/reportQuestion', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true, successAlert: true });
          document.getElementById('comment')
            ? (document.getElementById('comment').value = '')
            : null;
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = (e) => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  /*
  --------------------------------
    Function to hide Report box
  -------------------------------
  */
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  /*
  --------------------------------------
      Function to toggle Comment box
  --------------------------------------
  */
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  /*
  -----------------------------------
    Function to toggle Flash box
  -----------------------------------
  */
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  /*
  -------------------------------------------------------------------
    Function to Save flash Card And display new stored flash card
  -------------------------------------------------------------------
  */
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value === '') {
      return;
    }

    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2027question_bank/saveFlashCard', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          document.getElementById('flash_card').value = '';
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: item.id,
          };
          FD.callAPI(App_data.backend_api + '/cfa_2_2027question_bank/getFlashCards', params).then(
            (response) => {
              if (response.success) {
                this.setState({ ValidToken: true });
                if (response.flash_cards.length > 0) {
                  this.setState({ flash_form: 'col-md-12 hide_block' });
                  var flash_cards = response.flash_cards.map((items, index) => (
                    <li key={index}>
                      <div className=''>
                        <ul className='icon_list'>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._editFlash.bind(this, items)}
                            >
                              <i className='fa fa-pencil' />
                            </a>
                          </li>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._deleteFlash.bind(this, items)}
                            >
                              <i className='fa fa-close' />
                            </a>
                          </li>
                        </ul>
                        <div className={this.state.flash_class}>
                          <h4 />
                          <p>{items.flash_card}</p>
                        </div>
                      </div>
                    </li>
                  ));
                } else {
                  this.setState({
                    flash_form: 'col-md-12 display_block',
                  });
                  var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                }
                this.setState({ flash_data: flash_cards });
              } else {
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({
                  ValidToken: false,
                  flash_data: flash_cards,
                  flash_form: 'col-md-12 display_block',
                });
              }
              return response;
            },
          );
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  /*
  ------------------------------
    Function to Edit Flash card
  ------------------------------
  */
  _editFlash = (item, e) => {
    this.setState({ flash_form: 'col-md-12 display_block' });
    document.getElementById('flash_card').value = item.flash_card;
  };

  /*
  ------------------------------------
    Function to delete flash card
  ------------------------------------
  */
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2027question_bank/deleteFlashCard', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            flash_form: 'col-md-12 display_block',
          });
          document.getElementById('flash_card').value = '';
          var flash_cards = <p>No Flash Card Found</p>;
          this.setState({ flash_data: flash_cards });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  /*
  -----------------------------------
    Function to fetch Next question
  -----------------------------------
  */
  _getNext = () => {
    clearInterval(this.timer);

    const indexId = this.state.question_offset + 1;
    if (indexId === this.state.questions.length) {
      this.setState({
        showCompletionQuestion: true,
        next_block: 'card hide_block',
        markCompleted: false,
        markAsCompleted: false,
        markAsNotCompleted: false,
        display_cases: 'display_block',
      });
    } else {
      this.setState({ clicked: false });
      this.setState({
        display_loader: 'show_block',
        already_answered_status: '',
        validated: false,
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        save_text: `${language.LC().SAVE_QUESTION}`,
        report_block: 'card hide_block',
        rating: 0,
        ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
        bookmarkColor: '',
      });
      document.getElementById('comment') ? (document.getElementById('comment').value = '') : null;

      var insert_time = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        user_time_value: this.state.count,
      };
      FD.callAPI(App_data.backend_api + '/cfa_2_2027quizes/insertTimer', insert_time).then(
        (resp) => { },
      );

      if (indexId > 0) {
        this.setState({ previ_block: '' });
      }

      const questionData = this.state.questions[indexId];
      const selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
      const rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
      const answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
      let showAnswer = false;
      let selected = '';

      if (selectedChoice) {
        selected = selectedChoice;
        showAnswer = true;
      } else if (answerStatus) {
        if (rightAnswer === 1) {
          selected = `choice_${questionData.answer}`;
          showAnswer = true;
        } else if (!rightAnswer) {
          const correct = `choice_${questionData.answer}`;
          const choices = Object.keys(questionData).filter(
            (key) => key.startsWith('choice') && key !== `choice_${questionData.answer}`,
          );
          selected = choices.length > 0 ? choices[0] : '';
          showAnswer = true;
        }
      }

      let boxA = 'answer_box',
        boxB = 'answer_box',
        boxC = 'answer_box';
      let result_block = 'card hide_block',
        text_color = 'card-header',
        result = '',
        clicked = false;

      if (selected) {
        const correct = questionData.answer ? `choice_${questionData.answer}` : '';
        if (selected === 'choice_a') {
          boxA = selected === correct ? 'answer_box success' : 'answer_box failure';
        } else if (selected === 'choice_b') {
          boxB = selected === correct ? 'answer_box success' : 'answer_box failure';
        } else if (selected === 'choice_c') {
          boxC = selected === correct ? 'answer_box success' : 'answer_box failure';
        }
        if (correct) {
          if (selected === correct) {
            text_color = 'card-header text_success';
            result = 'CORRECT';
          } else {
            text_color = 'card-header text_failure';
            result = 'INCORRECT';
          }
          result_block = 'card show_block';
        }
        clicked = true;
      }

      this.setState({
        question_display: questionData,
        question_offset: indexId,
        selectedChoice: selected,
        choice: selected,
        clicked,
        choice_a: boxA,
        choice_b: boxB,
        choice_c: boxC,
        result_block,
        text_color,
        result,
        showAnswer,
        selected,
        display_loader: 'hide_block',
      });

      var data_check = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        question_id: questionData.id,
      };
      FD.callAPI(`${App_data.backend_api}/cfa_2_2027quizes/checkAnswered`, data_check).then(
        (resp) => {
          this.setState({ already_answered_status: resp.message });
        },
      );

      var params_fav = {
        token: this.state.token,
        question_id: questionData.id,
        idname: this.state.idname,
        chapter_id: this.state.chapter_id,
      };
      FD.callAPI(
        `${App_data.backend_api}/cfa_2_2027question_bank/getFavQuestions`,
        params_fav,
      ).then((responsefav) => {
        if (responsefav.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      });

      if (selectedChoice || selected) {
        this.setState({
          timer_stop: true,
          timerstopbtn: 'pause_btn icon-control-play',
        });
      } else {
        this.setState({
          timer_stop: false,
          timerstopbtn: 'pause_btn icon-control-pause',
        });
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      var params_rating = {
        token: this.state.token,
        question_id: questionData.id,
        idname: this.state.idname,
      };
      FD.callAPI(
        `${App_data.backend_api}/cfa_2_2027question_bank/getCfaratting`,
        params_rating,
      ).then((response) => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map((items) => {
            this.setState({
              rating: items.ratting,
              ratting_text: `${language.LC().RATED}`,
            });
          });
        } else {
          this.setState({
            rated: false,
            rating: 0,
            ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
          });
        }
      });
    }
  };

  /*
  -----------------------------------
    Function to fetch Previous question
  -----------------------------------
  */
  _getPrevious = () => {
    this.setState({ clicked: false });
    clearInterval(this.timer);
    this.setState({
      display_loader: 'show_block',
      already_answered_status: '',
      validated: false,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      report_block: 'card hide_block',
      rating: 0,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      bookmarkColor: '',
    });
    document.getElementById('comment') ? (document.getElementById('comment').value = '') : null;

    var insert_time = {
      token: this.state.token,
      idname: this.state.idname,
      quiz_id: this.state.quiz_id,
      user_time_value: this.state.count,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2027quizes/insertTimer', insert_time).then(
      (resp) => { },
    );

    const indexId = this.state.question_offset - 1;
    if (indexId < 0) {
      if (this.state.offset > 0) {
        this._getPreviousCase();
      } else {
        this.setState({ previ_block: 'card hide_block' });
      }
    } else {
      if (indexId === 0) {
        this.setState({ previ_block: 'card hide_block' });
      }

      const questionData = this.state.questions[indexId];
      const selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
      const rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
      const answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
      let showAnswer = false;
      let selected = '';

      if (selectedChoice) {
        selected = selectedChoice;
        showAnswer = true;
      } else if (answerStatus) {
        if (rightAnswer === 1) {
          selected = `choice_${questionData.answer}`;
          showAnswer = true;
        } else if (!rightAnswer) {
          const correct = `choice_${questionData.answer}`;
          const choices = Object.keys(questionData).filter(
            (key) => key.startsWith('choice') && key !== `choice_${questionData.answer}`,
          );
          selected = choices.length > 0 ? choices[0] : '';
          showAnswer = true;
        }
      }

      let boxA = 'answer_box',
        boxB = 'answer_box',
        boxC = 'answer_box';
      let result_block = 'card hide_block',
        text_color = 'card-header',
        result = '',
        clicked = false;

      if (selected) {
        const correct = questionData.answer ? `choice_${questionData.answer}` : '';
        if (selected === 'choice_a') {
          boxA = selected === correct ? 'answer_box success' : 'answer_box failure';
        } else if (selected === 'choice_b') {
          boxB = selected === correct ? 'answer_box success' : 'answer_box failure';
        } else if (selected === 'choice_c') {
          boxC = selected === correct ? 'answer_box success' : 'answer_box failure';
        }
        if (correct) {
          if (selected === correct) {
            text_color = 'card-header text_success';
            result = 'CORRECT';
          } else {
            text_color = 'card-header text_failure';
            result = 'INCORRECT';
          }
          result_block = 'card show_block';
        }
        clicked = true;
      }

      this.setState({
        question_display: questionData,
        question_offset: indexId,
        selectedChoice: selected,
        choice: selected,
        clicked,
        choice_a: boxA,
        choice_b: boxB,
        choice_c: boxC,
        result_block,
        text_color,
        result,
        showAnswer,
        selected,
        display_loader: 'hide_block',
      });

      var data_check = {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: this.state.quiz_id,
        question_id: questionData.id,
      };
      FD.callAPI(`${App_data.backend_api}/cfa_2_2027quizes/checkAnswered`, data_check).then(
        (resp) => {
          this.setState({ already_answered_status: resp.message });
        },
      );

      var params_fav = {
        token: this.state.token,
        question_id: questionData.id,
        idname: this.state.idname,
        chapter_id: this.state.chapter_id,
      };
      FD.callAPI(
        `${App_data.backend_api}/cfa_2_2027question_bank/getFavQuestions`,
        params_fav,
      ).then((responsefav) => {
        if (responsefav.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        }
      });

      if (selectedChoice || selected) {
        this.setState({
          timer_stop: true,
          timerstopbtn: 'pause_btn icon-control-play',
        });
      } else {
        this.setState({
          timer_stop: false,
          timerstopbtn: 'pause_btn icon-control-pause',
        });
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      var params_rating = {
        token: this.state.token,
        question_id: questionData.id,
        idname: this.state.idname,
      };
      FD.callAPI(
        `${App_data.backend_api}/cfa_2_2027question_bank/getCfaratting`,
        params_rating,
      ).then((response) => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map((items) => {
            this.setState({
              rating: items.ratting,
              ratting_text: `${language.LC().RATED}`,
            });
          });
        } else {
          this.setState({
            rated: false,
            rating: 0,
            ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
          });
        }
      });
    }
  };

  /*
  -----------------------------------
    Function to fetch Previous case
  -----------------------------------
  */
  _getPreviousCase = () => {
    clearInterval(this.timer);
    const indexId = this.state.offset - 1;

    const { all_cases } = this.state;

    if (indexId < 0) {
      return;
    }

    this.setState({
      display_loader: 'show_block',
      clicked: false,
      validated: false,
      already_answered_status: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      report_block: 'card hide_block',
      showCompletionQuestion: false,
      lastCase: this.state.cases_display.id,
      markCompleted: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      rating: 0,
      bookmarkColor: '',
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      result_block: 'card hide_block',
      previ_block: 'card hide_block',
      next_block: '',
      question_offset: 0,
      offset: indexId,
      case_id: all_cases[indexId],
    });

    if (indexId === 0) {
      this.setState({ previ_block_cases: 'card hide_block' });
    }
    if (indexId < this.state.cases_length - 1) {
      this.setState({ next_block_cases: '' });
    }

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      casesId: all_cases[indexId],
    };

    FD.callAPI(`${App_data.backend_api}/cfa_2_2027quizes/getCasesbyId`, data).then((resp) => {
      if (resp.success) {
        this.context.router.push({
          pathname: `/cfa2/2027/beginquiz/${this.state.quiz_id}/${indexId}`,
        });

        this.setState({
          cases_display: resp.casesdiscription,
          chapter_id: resp.casesdiscription.chapter_no_2025,
          case_no: resp.casesdiscription.case_number,
          chapter_no_2025: resp.casesdiscription.chapter_no_2025,
        });

        var data = {
          token: this.state.token,
          idname: this.state.idname,
          chapter_id: resp.casesdiscription.chapter_no_2025,
        };

        FD.callAPI(`${App_data.backend_api}/cfa_2_2027question_bank/getChaptersbyID`, data).then(
          (respchapter) => {
            if (respchapter.success) {
              this.setState({
                chaptername: respchapter.chapterdata.chapter_name,
                chapters: respchapter.chapterdata,
              });

              const param = {
                token: this.state.token,
                idname: this.state.idname,
                case_id: resp.casesdiscription.id,
                isQuiz: true,
                quiz_id: this.state.quiz_id,
              };

              FD.callAPI(
                `${App_data.backend_api}/cfa_2_2027question_bank/getCasesquestion`,
                param,
              ).then((resp_question) => {
                if (resp_question.success) {
                  const questionData = resp_question.questions_details[0];
                  const selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
                  const rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
                  const answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
                  let showAnswer = false;
                  let selected = '';

                  if (selectedChoice) {
                    selected = selectedChoice;
                    showAnswer = true;
                  } else if (answerStatus) {
                    if (rightAnswer === 1) {
                      selected = `choice_${questionData.answer}`;
                      showAnswer = true;
                    } else if (!rightAnswer) {
                      const correct = `choice_${questionData.answer}`;
                      const choices = Object.keys(questionData).filter(
                        (key) =>
                          key.startsWith('choice') && key !== `choice_${questionData.answer}`,
                      );
                      selected = choices.length > 0 ? choices[0] : '';
                      showAnswer = true;
                    }
                  }

                  let boxA = 'answer_box',
                    boxB = 'answer_box',
                    boxC = 'answer_box';
                  let result_block = 'card hide_block',
                    text_color = 'card-header',
                    result = '',
                    clicked = false;

                  if (selected) {
                    const correct = questionData.answer ? `choice_${questionData.answer}` : '';
                    if (selected === 'choice_a') {
                      boxA = selected === correct ? 'answer_box success' : 'answer_box failure';
                    } else if (selected === 'choice_b') {
                      boxB = selected === correct ? 'answer_box success' : 'answer_box failure';
                    } else if (selected === 'choice_c') {
                      boxC = selected === correct ? 'answer_box success' : 'answer_box failure';
                    }
                    if (correct) {
                      if (selected === correct) {
                        text_color = 'card-header text_success';
                        result = 'CORRECT';
                      } else {
                        text_color = 'card-header text_failure';
                        result = 'INCORRECT';
                      }
                      result_block = 'card show_block';
                    }
                    clicked = true;
                  }

                  this.setState({
                    question_display: questionData,
                    question_length: resp_question.questions_details.length,
                    questions: resp_question.questions_details,
                    selectedChoice: selected,
                    choice: selected,
                    clicked,
                    choice_a: boxA,
                    choice_b: boxB,
                    choice_c: boxC,
                    result_block,
                    text_color,
                    result,
                    showAnswer,
                    selected,
                    display_loader: 'hide_block',
                  });

                  if (!selected) {
                    this.timer = setInterval(this.tick.bind(this), 1000);
                    this.setState({
                      timer_stop: false,
                      timerstopbtn: 'pause_btn icon-control-pause',
                      timer_display: 'card-block',
                    });
                  } else {
                    this.setState({
                      timer_stop: true,
                      timerstopbtn: 'pause_btn icon-control-play',
                      timer_display: 'card-block',
                    });
                  }
                  var data_check = {
                    token: this.state.token,
                    idname: this.state.idname,
                    quiz_id: this.state.quiz_id,
                    question_id: questionData.id,
                  };

                  FD.callAPI(
                    `${App_data.backend_api}/cfa_2_2027quizes/checkAnswered`,
                    data_check,
                  ).then((resp_inner) => {
                    this.setState({
                      already_answered_status: resp_inner.message,
                    });
                  });
                  var params_fav = {
                    token: this.state.token,
                    question_id: questionData.id,
                    idname: this.state.idname,
                    chapter_id: this.state.chapter_id,
                  };
                  FD.callAPI(
                    `${App_data.backend_api}/cfa_2_2027question_bank/getFavQuestions`,
                    params_fav,
                  ).then((responsefav) => {
                    if (responsefav.success) {
                      this.setState({
                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                        bookmarkColor: 'rgb(54, 141, 84)',
                        save_text: `${language.LC().Question_Saved}`,
                      });
                    }
                  });
                  // Fetch rating for this question
                  var params_rating = {
                    token: this.state.token,
                    question_id: questionData.id,
                    idname: this.state.idname,
                  };
                  FD.callAPI(
                    `${App_data.backend_api}/cfa_2_2027question_bank/getCfaratting`,
                    params_rating,
                  ).then((response) => {
                    if (response.success) {
                      this.setState({ rated: true });
                      response.ratting.map((items) => {
                        this.setState({
                          rating: items.ratting,
                          ratting_text: `${language.LC().RATED}`,
                        });
                      });
                    } else {
                      this.setState({
                        rated: false,
                        rating: 0,
                        ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
                      });
                    }
                  });
                }
              });
            }
          },
        );
      }
    });
  };

  _getNextCase = () => {
    clearInterval(this.timer);
    const indexId = this.state.offset + 1;

    const { all_cases } = this.state;

    if (indexId >= this.state.cases_length) {
      return;
    }

    this.setState({
      display_loader: 'show_block',
      clicked: false,
      validated: false,
      already_answered_status: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      report_block: 'card hide_block',
      showCompletionQuestion: false,
      lastCase: this.state.cases_display.id,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      rating: 0,
      bookmarkColor: '',
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      result_block: 'card hide_block',
      previ_block: 'card hide_block',
      next_block: '',
      question_offset: 0,
      offset: indexId,
      case_id: all_cases[indexId],
    });

    if (indexId > 0) {
      this.setState({ previ_block_cases: '' });
    }
    if (indexId === this.state.cases_length - 1) {
      this.setState({ next_block_cases: 'card hide_block' });
    }

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      casesId: all_cases[indexId],
    };

    FD.callAPI(`${App_data.backend_api}/cfa_2_2027quizes/getCasesbyId`, data).then((casesData) => {
      if (casesData.success) {
        this.context.router.push({
          pathname: `/cfa2/2027/beginquiz/${this.state.quiz_id}/${indexId}`,
        });

        this.setState({
          cases_display: casesData.casesdiscription,
          chapter_id: casesData.casesdiscription.chapter_no_2025,
          case_no: casesData.casesdiscription.case_number,
          chapter_no_2025: casesData.casesdiscription.chapter_no_2025,
        });

        var data = {
          token: this.state.token,
          idname: this.state.idname,
          chapter_id: casesData.casesdiscription.chapter_no_2025,
        };

        FD.callAPI(`${App_data.backend_api}/cfa_2_2027question_bank/getChaptersbyID`, data).then(
          (respchapter) => {
            if (respchapter.success) {
              this.setState({
                chaptername: respchapter.chapterdata.chapter_name,
                chapters: respchapter.chapterdata,
              });

              const param = {
                token: this.state.token,
                idname: this.state.idname,
                case_id: casesData.casesdiscription.id,
                isQuiz: true,
                quiz_id: this.state.quiz_id,
              };

              FD.callAPI(
                `${App_data.backend_api}/cfa_2_2027question_bank/getCasesquestion`,
                param,
              ).then((resp_question) => {
                if (resp_question.success) {
                  const questionData = resp_question.questions_details[0];
                  const selectedChoice = questionData['cfa2_2027_answer_quizzes.selected_choice'] || '';
                  const rightAnswer = questionData['cfa2_2027_answer_quizzes.answer'] || '';
                  const answerStatus = questionData['cfa2_2027_answer_quizzes.id'] || '';
                  let showAnswer = false;
                  let selected = '';

                  if (selectedChoice) {
                    selected = selectedChoice;
                    showAnswer = true;
                  } else if (answerStatus) {
                    if (rightAnswer === 1) {
                      selected = `choice_${questionData.answer}`;
                      showAnswer = true;
                    } else if (!rightAnswer) {
                      const correct = `choice_${questionData.answer}`;
                      const choices = Object.keys(questionData).filter(
                        (key) =>
                          key.startsWith('choice') && key !== `choice_${questionData.answer}`,
                      );
                      selected = choices.length > 0 ? choices[0] : '';
                      showAnswer = true;
                    }
                  }

                  let boxA = 'answer_box',
                    boxB = 'answer_box',
                    boxC = 'answer_box';
                  let result_block = 'card hide_block',
                    text_color = 'card-header',
                    result = '',
                    clicked = false;

                  if (selected) {
                    const correct = questionData.answer ? `choice_${questionData.answer}` : '';
                    if (selected === 'choice_a') {
                      boxA = selected === correct ? 'answer_box success' : 'answer_box failure';
                    } else if (selected === 'choice_b') {
                      boxB = selected === correct ? 'answer_box success' : 'answer_box failure';
                    } else if (selected === 'choice_c') {
                      boxC = selected === correct ? 'answer_box success' : 'answer_box failure';
                    }
                    if (correct) {
                      if (selected === correct) {
                        text_color = 'card-header text_success';
                        result = 'CORRECT';
                      } else {
                        text_color = 'card-header text_failure';
                        result = 'INCORRECT';
                      }
                      result_block = 'card show_block';
                    }
                    clicked = true;
                  }

                  this.setState({
                    question_display: questionData,
                    question_length: resp_question.questions_details.length,
                    questions: resp_question.questions_details,
                    selectedChoice: selected,
                    choice: selected,
                    clicked,
                    choice_a: boxA,
                    choice_b: boxB,
                    choice_c: boxC,
                    result_block,
                    text_color,
                    result,
                    showAnswer,
                    selected,
                    display_loader: 'hide_block',
                  });

                  if (!selected) {
                    this.timer = setInterval(this.tick.bind(this), 1000);
                    this.setState({
                      timer_stop: false,
                      timerstopbtn: 'pause_btn icon-control-pause',
                      timer_display: 'card-block',
                    });
                  } else {
                    this.setState({
                      timer_stop: true,
                      timerstopbtn: 'pause_btn icon-control-play',
                      timer_display: 'card-block',
                    });
                  }

                  var data_check = {
                    token: this.state.token,
                    idname: this.state.idname,
                    quiz_id: this.state.quiz_id,
                    question_id: questionData.id,
                  };

                  FD.callAPI(
                    `${App_data.backend_api}/cfa_2_2027quizes/checkAnswered`,
                    data_check,
                  ).then((resp_inner) => {
                    this.setState({
                      already_answered_status: resp_inner.message,
                    });
                  });
                  var params_fav = {
                    token: this.state.token,
                    question_id: questionData.id,
                    idname: this.state.idname,
                    chapter_id: this.state.chapter_id,
                  };
                  FD.callAPI(
                    `${App_data.backend_api}/cfa_2_2027question_bank/getFavQuestions`,
                    params_fav,
                  ).then((responsefav) => {
                    if (responsefav.success) {
                      this.setState({
                        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                        bookmarkColor: 'rgb(54, 141, 84)',
                        save_text: `${language.LC().Question_Saved}`,
                      });
                    }
                  });
                  // Fetch rating for this question
                  var params_rating = {
                    token: this.state.token,
                    question_id: questionData.id,
                    idname: this.state.idname,
                  };
                  FD.callAPI(
                    `${App_data.backend_api}/cfa_2_2027question_bank/getCfaratting`,
                    params_rating,
                  ).then((response) => {
                    if (response.success) {
                      this.setState({ rated: true });
                      response.ratting.map((items) => {
                        this.setState({
                          rating: items.ratting,
                          ratting_text: `${language.LC().RATED}`,
                        });
                      });
                    } else {
                      this.setState({
                        rated: false,
                        rating: 0,
                        ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
                      });
                    }
                  });
                }
              });
            }
          },
        );
      }
    });
  };

  markCompleted() {
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  }

  markNotCompleted() {
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  }

  changeCompletionStatus(e) {
    e.preventDefault();

    if (!this.state.markAsCompleted && !this.state.markAsNotCompleted) {
      return;
    }

    var data = {
      token: this.state.token,
      idname: this.state.idname,
      case_no: this.state.case_no,
      completion_status: this.state.markAsCompleted ? 1 : 0,
      exam_type: this.state.exam_type,
      chapter_id: this.state.chapter_id,
    };

    FD.callAPI(App_data.backend_api + '/cfa_2_2027question_bank/updateCases', data).then(
      (casesData) => {
        if (casesData.success) {
          this.setState({
            markCompleted: true,
            showCompletionQuestion: false,
          });

          let indexId = this.state.offset + 1;
          if (indexId < this.state.cases_length) {
            this._getNextCase();
          }
        }
      },
    );
  }

  render() {
    const { rating } = this.state;
    const { clicked } = this.state;
    let questions_data_display = this.state.question_display;

    const choice_a = 'a';
    const choice_b = 'b';
    const choice_c = 'c';

    let data,
      question_data = '';
    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }

    data = (
      <div className='row'>
        <div className='col-md-12'>
          <div className='card font-lusitana'>
            <div className='card-header'>
              <span>
                {this.state.cases_display.case_name_2025 || this.state.cases_display.case_name}
              </span>
              <div className='float-right text-right'>
                <i
                  className={
                    'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block_cases
                  }
                  onClick={this._getPreviousCase}
                />
                <i
                  className={
                    'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block_cases
                  }
                  onClick={this._getNextCase}
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <div className='row'>
                    <div className='col-sm-12'>
                      {renderHTMLContent(
                        this.state.cases_display.case,
                        'div',
                        'margin_bottom_40 view_questionhtml bg_blue',
                        { contentEditable: 'false' },
                      )}
                    </div>
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='timer_outer'>
                    <i className='fa fa-clock-o' />
                    <span className='timer_box'>{display_time}</span>
                  </div>
                  <span className={'quiz_timer_btn ' + this.state.timer_display}>
                    <button
                      type='button'
                      className={this.state.timerstopbtn}
                      onClick={this._timer_funct.bind(this, questions_data_display)}
                    />
                  </span>
                  <p className='text-danger'>
                    {renderHTMLContent(this.state.count_end_message, 'div', '', {
                      contentEditable: 'false',
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    question_data = (
      <div className='row'>
        <div className='col-md-12'>
          <div className='card font-lusitana'>
            <div className='card-header'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                className='margin_right_20'
                width='30'
                alt=''
              />
              {language.LC().QUESTION} {questions_data_display.question_number + ' - '}
              <div className='float-right text-right'>
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this._getPrevious}
                />
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this._getNext}
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <ViewQuestion
                    {...questions_data_display}
                    {...this.props}
                    setAnswer={this._getAnswer}
                    showAnswer={clicked}
                    correctChoice={`choice_${questions_data_display.answer}`}
                    selectedChoice={this.state.selectedChoice}
                    onValidate={() => this._getResult(questions_data_display)}
                  >
                    <div className='d-flex align-items-center'>
                      <div className='validate-save-report-wrap'>
                        <ValidateSaveReportIcon
                          isQue={true}
                          _getResult={this._getResult}
                          clicked={this.state.clicked}
                          _saveQuestion={this._saveQuestion}
                          _displayReportForm={this._displayReportForm}
                          all_questions={questions_data_display}
                          save_text={this.state.save_text}
                          bookmarkCSS={this.state.bookmarkCSS}
                          bookmarkColor={this.state.bookmarkColor}
                          disabled={!this.state.selectedChoice || this.state.clicked}
                        />
                      </div>
                      <div
                        className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right mr-10'
                        style={{ marginRight: '650px' }}
                      >
                        <span className=' margin_bottom_0 margin_right_10 font-16px'>
                          {this.state.ratting_text}
                        </span>
                        <div className='star_rating_wrap'>
                          <StarRatings
                            rating={this.state.rating}
                            starRatedColor='rgb(255, 180, 0)'
                            starEmptyColor='rgb(51, 51, 51)'
                            starDimension='20px'
                            starHoverColor='rgb(255, 180, 0)'
                            starSpacing='2px'
                            changeRating={this.onStarClick.bind(this, questions_data_display)}
                            numberOfStars={5}
                            name='rate1'
                          />
                        </div>
                      </div>
                    </div>
                  </ViewQuestion>
                </div>
                <div className='col-sm-3' />
              </div>
            </div>
          </div>
          <div className={`${this.state.result_block} font-lusitana font-16px`}>
            <div className={this.state.text_color}>{this.state.result}</div>
            <div className='card-block'>
              {renderHTMLContent(questions_data_display.explanation, 'div', '', {
                contentEditable: 'false',
              })}
            </div>
          </div>
          <div className={this.state.report_block}>
            <div className='card-header'>{language.LC().REPORT}</div>

            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-md-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong>{language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-md-12 margin_bottom_10'>
                    <textarea
                      id='comment'
                      name='comment'
                      rows='6'
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class'
                      onClick={this._reportQuestion.bind(this, questions_data_display)}
                    >
                      {language.LC().REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={this._hideReportForm.bind(this, questions_data_display)}
                    >
                      {language.LC().CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={this.onClose}
                    >
                      {' '}
                      {language.LC().CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
    if (this.state.showCompletionQuestion) {
      question_data = (
        <div className={'complete-section-wrap ' + this.state.display_cases}>
          <div className='card'>
            <div className='card-header text-center'>
              {language.LC().Mark_this_Question_as_Completed}
              <div onClick={this.changeCompletionStatus} className='float-right text-right'>
                <i className='fa fa-angle-right ques_arrow pointer_class' />
              </div>
            </div>

            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-12 text-center'>
                  <div className='row'>
                    <div className='col-sm-12 col-md-12 '>
                      <div className='quation-img'>
                        <img
                          src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                          className='margin_bottom_10'
                          alt=''
                        />
                      </div>
                      <div
                        contentEditable='false'
                        suppressContentEditableWarning={true}
                        className='margin_bottom_10 view_questionhtml bg_blue'
                      >
                        {' '}
                        {language.LC().MARK_THIS_QUESTION_AS_COMPLETED}{' '}
                      </div>
                    </div>
                    <div className='complete-or-not-wrap'>
                      <div className='check-button-wrap'>
                        <div className='card-actions float-right'>
                          <label className='check_container margin_bottom_0'>
                            {' '}
                            {language.LC().COMPLETED}
                            <input
                              type='checkbox'
                              id='mark_completed'
                              name='mark_completed'
                              value='select'
                              onClick={this.markCompleted.bind(this)}
                              checked={this.state.markAsCompleted}
                            />
                            <span className='checkmark' />
                          </label>
                        </div>
                        <div className='card-actions float-right'>
                          <label className='check_container margin_bottom_0'>
                            {language.LC().NOT_COMPLETED}
                            <input
                              type='checkbox'
                              id='mark_not_completed'
                              name='mark_not_completed'
                              value='select'
                              onClick={this.markNotCompleted.bind(this)}
                              checked={this.state.markAsNotCompleted}
                            />
                            <span className='checkmark' />
                          </label>
                        </div>
                      </div>
                      <div className='d-block text-center complete-quation-submit'>
                        <button
                          disabled={this.state.markCompleted}
                          onClick={this.changeCompletionStatus.bind(this)}
                          className='btn btn-primary pointer_class'
                        >
                          {' '}
                          {this.state.markCompleted ? 'Submitted' : language.LC().SUBMIT}{' '}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.markCompleted) {
      document.getElementById('mark_not_completed') &&
        document.getElementById('mark_not_completed').checked
        ? (document.getElementById('mark_not_completed').checked = false)
        : '';
      document.getElementById('mark_completed') && document.getElementById('mark_completed').checked
        ? (document.getElementById('mark_completed').checked = false)
        : '';
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-sm-8 margin_bottom_20'>
            <h1 className='section_head'>
              {' '}
              {language.LC().QUIZ_ID}: {this.state.quiz_id}
            </h1>
            {/*<h6 className="text-danger">{this.state.already_answered_status}</h6>*/}
          </div>
          <div className='col-sm-4 margin_bottom_20 text-sm-right'>
            <button className='btn btn-primary pointer_class' onClick={this._getSummary}>
              {language.LC().BACK_TO_SUMMARY}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 margin_bottom_20'>{data}</div>
        </div>
        <div className='row'>
          <div className='col-sm-12 col-md-12 margin_bottom_20'>{question_data}</div>
        </div>

        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}
class TooltipItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <i className='fa fa-info-circle' id={'Tooltip-' + this.props.id}></i>
        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          {this.props.tooltip}
        </Tooltip>
      </span>
    );
  }
}

export default Cfa2Beginquiz;



// WEBPACK FOOTER //
// ./src/views/CFA2-2027/Quizzes/Cfa2Beginquiz.js